import { defineAsyncComponent, defineComponent, h } from "vue";

// Dynamically import components based on prop value
export const NoteWriter = defineAsyncComponent(() => import("./NoteWriter.vue"));
export const LegacyNoteWriter = defineAsyncComponent(() => import("./LegacyNoteWriter.vue"));

// Default export that can be used with a prop to determine which component to render
export default defineComponent({
  name: "NoteWriterSelector",
  components: {
    NoteWriter,
    LegacyNoteWriter,
  },
  props: {
    useLegacyNoteWriter: {
      type: Boolean,
      default: false,
      description:
        "When true, uses the legacy LegacyNoteWriter component. When false (default), uses the new NoteWriter component with OpenAPI support.",
    },
  },
  setup(props) {
    return () => {
      const Component = props.useLegacyNoteWriter ? LegacyNoteWriter : NoteWriter;
      return h(Component);
    };
  },
});

// Named exports for direct usage
export { LegacyNoteWriter as LegacyNoteWriterComponent };
export { NoteWriter as NoteWriterComponent };
